import { useEffect } from 'react';

const SITE_NAME = 'Azamein';

/** Set the browser tab title for a page, e.g. "Templates | Azamein". */
export const useDocumentTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Elegant Simcha Invitations`;
  }, [title]);
};
